import {AppBar, Box, ButtonBase, Fade, Popover, Toolbar} from "@mui/material";
import React, {useRef, useState} from "react";
import {Link} from "react-router-dom";

import NavProfile from "./NavProfile";
import {useAppSelector} from "../../store/hooks";
import selectUserProfile from "../../store/userProfile/selectUserProfile";
import UserAvatar from "./UserAvatar";

function Nav(props: {
	logo: string;
	children?: React.ReactNode;
	quickLinks?: React.ReactNode;
	organisationName?: string;
}) {
	const [profileOpen, setProfileOpen] = useState(false);
	const profileButton = useRef<HTMLButtonElement>(null);

	function closeProfile() {
		setProfileOpen(false);
	}

	const userProfile = useAppSelector(selectUserProfile);
	const profileName =
		userProfile.firstName && userProfile.lastName
			? `${userProfile.firstName} ${userProfile.lastName}`
			: "";
	const profileUserName = userProfile.userName;

	return (
		<>
			<AppBar
				sx={{
					boxShadow: "none",
					justifyContent: "center",
					zIndex: (theme) => theme.zIndex.drawer + 2,
				}}
			>
				<Toolbar>
					<Link to="/">
						<Box
							component="img"
							src={props.logo}
							alt="Logo"
							sx={{
								maxHeight: (theme) => theme.mixins.toolbar.minHeight,
								verticalAlign: "middle",
							}}
						/>
					</Link>

					<Box ml={3} flexGrow={1}>
						{props.children}
					</Box>

					{props.quickLinks && (
						<Fade in={!profileOpen}>
							<Box mr={2.5}>{props.quickLinks}</Box>
						</Fade>
					)}

					<Fade in={!profileOpen}>
						<ButtonBase
							ref={profileButton}
							onClick={() => setProfileOpen(true)}
							sx={{borderRadius: "50%"}}
						>
							<UserAvatar user={userProfile} size="small" />
						</ButtonBase>
					</Fade>
				</Toolbar>
			</AppBar>

			<Toolbar />

			<Popover
				open={profileOpen}
				anchorEl={profileButton.current}
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				slotProps={{
					paper: {
						sx: {
							minWidth: 280,
							display: "flex",
							flexDirection: "column",
							maxHeight: (theme) => `calc(100vh - ${theme.spacing(2 + 2)})`,
						},
					},
				}}
				onClose={closeProfile}
			>
				<NavProfile
					organisationName={props.organisationName}
					userId={userProfile.id}
					profileName={profileName}
					profileUserName={profileUserName}
					avatar={<UserAvatar user={userProfile} />}
					onClick={closeProfile}
				/>
			</Popover>
		</>
	);
}

export default Nav;
